var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6.974 3.075-2.03 1.128a2.261 2.261 0 0 0-1.158 1.843 16.676 16.676 0 0 0 8.702 15.649c.68.368 1.5.363 2.176-.012l2.03-1.13a.812.812 0 0 0 .229-1.229l-1.95-2.332a1 1 0 0 0-1.253-.233l-.925.514a1 1 0 0 1-1.264-.245l-.63-.781a20 20 0 0 1-3.325-5.978l-.33-.948a1 1 0 0 1 .458-1.203l.925-.515a1 1 0 0 0 .463-1.187L8.14 3.529a.812.812 0 0 0-1.166-.454ZM13.04 4.212a6.364 6.364 0 0 1 5.915 10.56"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.75 7.628c.55-.094 1.129 0 1.652.269.523.268.964.697 1.26 1.226.295.528.43 1.129.386 1.715a2.649 2.649 0 0 1-.634 1.55"
})));
SvgPhone.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export default ForwardRef;